import script from "./editAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./editAddress.vue?vue&type=script&setup=true&lang=js"

import "./editAddress.vue?vue&type=style&index=0&id=239b8dc6&scoped=true&lang=less"

import exportComponent from "E:\\A-OnlineServiceCenter\\stableBuilds - 副本\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-239b8dc6"]])

export default __exports__